module.exports = __webpack_public_path__ + "img/banner3.770a2e20.jpg";